import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { get } from 'lodash';
import { Grid, Icon, Label } from 'semantic-grab-ui/src';
import FilterDialog from 'components/form/trident-campaigns/FilterDialog';
import FilterTab from 'components/form/trident-campaigns/FilterTab';

interface Filter {
  lhs: string;
  operator: string;
  rhs: any;
}

interface Props {
  filters: Filter[];
  filterTypes: Object;
  onChange: (filters: Filter[]) => void;
  title?: string;
}

interface State {
  // No internal state needed as this is a controlled component
}

class TridentCampaignAdvancedFilters extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  openDialog = (callback: (filter: Filter) => void, lhs: string, operator: string, rhs: any, isEdit: boolean = false) => {
    const com = this;
    const modalContainer = document.getElementById('modalPlaceholder');

    if (!modalContainer) {
      console.error('Modal placeholder not found. Make sure the page has a <div id="modalPlaceholder" />');
      return;
    }

    // pop up set-filter dialog
    ReactDOM.render(
      <FilterDialog
        open
        onCancel={com.closeDialog}
        onSave={callback}
        filterTypes={this.props.filterTypes}
        lhs={lhs}
        operator={operator}
        rhs={rhs}
        isEdit={isEdit}
      />,
      modalContainer,
    );
  };

  closeDialog = () => {
    const modalContainer = document.getElementById('modalPlaceholder');
    if (modalContainer) {
      ReactDOM.render(<div />, modalContainer);
    }
  };

  addFilter = () => {
    this.openDialog(
      (newFilter: Filter) => {
        this.closeDialog();
        const updatedFilters = [...this.props.filters, newFilter];
        this.props.onChange(updatedFilters);
      },
      '',
      '',
      '',
      false, // isEdit = false for adding new filter
    );
  };

  deleteFilter = (index: number) => {
    const curFilters = [...this.props.filters];
    curFilters.splice(index, 1);
    this.props.onChange(curFilters);
  };

  editFilter = (index: number) => {
    const targetFilter = get(this.props.filters, `[${index}]`, {
      lhs: '',
      operator: '',
      rhs: '',
    });
    this.openDialog(
      (updatedFilter: Filter) => {
        const curFilters = [...this.props.filters];
        curFilters[index] = updatedFilter;
        this.closeDialog();
        this.props.onChange(curFilters);
      },
      targetFilter.lhs,
      targetFilter.operator,
      targetFilter.rhs,
      true, // isEdit = true for editing existing filter
    );
  };

  render() {
    const { filters, title = 'Advanced Filters: ' } = this.props;

    return (
      <React.Fragment>
        <div id="modalPlaceholder" />
        <Grid.Row>

          <Grid.Column>
            <div style={{
              fontWeight: 600,
              fontSize: '14px',
              color: '#333',
              display: 'inline-block',
              marginRight: '10px',
            }}>
              <span>{title}</span>
            </div>
            {filters.map((filter, index) => {
              return (
                <FilterTab
                  key={`${filter.lhs} ${filter.operator} ${filter.rhs}`}
                  lhs={filter.lhs}
                  operator={filter.operator}
                  rhs={filter.rhs}
                  index={index}
                  onDelete={this.deleteFilter}
                  onEdit={this.editFilter}
                />
              );
            })}

            <Label as="a" onClick={this.addFilter}>
              <Icon name="plus" />
              Add filter
            </Label>
          </Grid.Column>
        </Grid.Row>
      </React.Fragment>
    );
  }
}

export default TridentCampaignAdvancedFilters;
